export const translation = {
  getStared: { 'en-us': 'Get started', 'fr-fr': 'Commencez' },
  encrypt: {
    'en-us': `${new Date().getFullYear()} Swiftask. All rights reserved`,
    'fr-fr': `${new Date().getFullYear()} Swiftask. Tous droits réservés`,
  },
};
